<template>
  <div id="app">
    <SignatureBlock />
  </div>
</template>

<script>
import SignatureBlock from './components/SignatureBlock.vue';

export default {
  name: 'App',
  components: {
    SignatureBlock
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
